import { FC } from 'react';

import Page from 'modules/_shared/components/Pages/Page';
import CustomLoading from 'modules/_shared/components/CustomLoading';

import { useEquityMarketAdminPanel } from './context/EquityMarketAdminPanelContext';

import EquityMarketAdminPanelHeader from './components/EquityMarketAdminPanelHeader';
import EquityMarketAdminPanelSummaryCard from './components/EquityMarketAdminPanelSummaryCard';
import EquityMarketAdminPanelOffersList from './components/EquityMarketAdminPanelOffersList';

import '../../styles/Trading.scss';

const EquityMarketAdminPanel: FC = () => {
  const { data, actions } = useEquityMarketAdminPanel();

  return (
    <Page id="equity-market-admin-panel-page">
      <EquityMarketAdminPanelHeader
        societyId={data.societyId}
        societyName={data.societyName}
        equityMarketStatus={data.equityMarketStatus}
        onEquityMarketStatusChange={actions.handleEquityMarketStatusChange}
      />

      <EquityMarketAdminPanelSummaryCard
        sellOffersSummary={data.sellOffersSummary}
        buyOffersSummary={data.buyOffersSummary}
        pendingOperationsCount={data.pendingOperationsCount}
        sellOffers={data.sellOffers}
        buyOffers={data.buyOffers}
        operations={data.operations}
      />

      <div className="nk-block">
        <EquityMarketAdminPanelOffersList
          societyId={data.societyId}
          sellOffers={data.sellOffers}
          buyOffers={data.buyOffers}
          operations={data.operations}
          onViewOfferDetail={actions.handleViewOfferDetail}
          onViewOperationDetail={actions.handleViewOperationDetail}
          onUpdateOperationStatus={actions.handleUpdateOperationStatus}
          onTogglePartnerAccess={actions.handleTogglePartnerEquityMarketAccess}
          isLoading={data.isLoading}
        />
      </div>

      {data.isLoading && <CustomLoading />}
    </Page>
  );
};

export default EquityMarketAdminPanel;
